import styled, { css } from 'styled-components';
import { RecommendationsActivityType } from 'src/api/me/types';
import { Icon } from 'src/components';

/* istanbul ignore next: tested visually */
export const CardContainer = styled.div<{ $type: RecommendationsActivityType }>(
  ({ theme, $type }) => css`
    position: relative;
    background-color: ${$type === 'learn'
      ? theme.co.success98
      : $type === 'immerse'
        ? theme.co.error98
        : theme.co.information98};
    border-radius: ${theme.bo.medium};
    padding: ${theme.sz.s2} ${theme.sz.s4};
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s1};
  `,
);

export const CardTitle = styled.h3(
  ({ theme }) => css`
    ${theme.typography.paragraph.m};
    color: ${theme.co.secondary0};
    margin: ${theme.sz.s0};
  `,
);

export const CardValue = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.s};
    color: ${theme.co.secondary0};
  `,
);

export const ValueContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: end;
    justify-content: space-between;
    gap: ${theme.sz.s2};
  `,
);

export const DifferenceContainer = styled.button(
  () => css`
    display: flex;
    cursor: pointer;
    padding: unset;
    border: unset;
    background-color: unset;
  `,
);

export const DifferenceArrow = styled(Icon)<{ $isPositive: boolean }>(
  ({ theme, $isPositive }) => css`
    color: ${$isPositive ? theme.co.success40 : theme.co.error60};
    font-size: ${theme.sz.s6};

    ${!$isPositive &&
    css`
      transform: rotate(180deg);
    `}
  `,
);

export const DifferenceValue = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.xxs};
  `,
);

export const ToastContainer = styled.div(
  ({ theme }) => css`
    position: absolute;
    z-index: 1;
    left: ${theme.sz.s12};
    right: 0;
    top: calc(100% + ${theme.sz.s3});
  `,
);
